
// 西药房门诊发药 接口相关的函数
import request from "@/untils/request.js"

/**
 * 
 *  post
 *  
 */

// 西药处方发药明细 = 发药
export const fySave = (data) => {
    return request.post("/outpatient/fy/fySave", data)
}

// 西药处方发药明细 = 发药V2
export const fySaveV2 = (data) => {
    return request.post("/outpatient/api/v2/outpatient/dispenses/outp-add", data)
}

// 西药处方退药
export const tySave = (data) => {
    return request.post("/outpatient/ty/addRet", data)
}
// 西退药退费接口
export const tyrefund = (data) => {
    return request.post("/outpatient/ty/refund", data)
}

// 门诊订单明细id查询可选择的药房批次信息 V2
export const outpTable = (params) => {
    return request.get("/outpatient/api/v2/outpatient/dispenses/outp-table",  { params })
}

//  中药处方退药
export const tyZYSave = (data) => {
    return request.post("/outpatient/zyty/addTcmRet", data)
}

/**
 * 
 * get 
 *  
 */
// 西药处方列表-点击退药查看退药数据
export const getRefundDrug = (params) => {
    return request.get("/outpatient/rxmain/getRefundDrug", { params })
}
// 中药处方列表-点击退药查看退药数据
export const getZYRefundDrug = (params) => {
    return request.get("/outpatient/zyty/getRefundDrug", { params })
}
// 西药房门诊发药-查询患者信息
export const selectPatientInfo = (params) => {
    return request.get("/outpatient/dis/selectPatientInfo", { params })
}
// 西药房门诊发药-查询患者信息 V2
export const selectPatientInfoV2 = (params) => {
    return request.get("/outpatient/api/v2/outpatient/dispenses/pending-patients", { params })
}
// 西药房门诊发药-查询患者信息 V2 => 查询患者全部待发药订单
export const getPatientInfoV2 = (params) => {
    return request.get("/outpatient/api/v2/outpatient/dispenses/pending-orders", { params })
}

// 中药房门诊发药-查询患者信息
export const selectZYPatientInfo = (params) => {
    return request.get("/outpatient/tcmDis/selectPatientInfo", { params })
}


// 西药房门诊退药列表
export const rxmainPage = (params) => {
    return request.get("/outpatient/rxmain/page", { params })
}
// 西药房门诊退药列表 => 删除
export const deltyrefund = (params) => {
    return request.get("/outpatient/ty/deleteRefund", { params })
}

// 中药房门诊退药列表
export const rxmainZYPage = (params) => {
    return request.get("/outpatient/tcmrxmain/page", { params })
}

/**
 * 
 * DELETE 
 *  
 */
// 西药房其他入库草稿删除
// export const deleteDoc = (params) => {
//     return request.delete("/outpatient/dugDoc/deleteDoc", { params })
// }


/*
	Others
*/
// 护理执行计划-查询处方是否有护理执行
export const getDrxExePlanInfo = (params) => {
    return request.get("/outpatient/exetable/getDrxExePlanInfo", { params })
}

// 暴露
export default{
	// 查询患者信息
	selectPatientInfo,
	// 发药
	fySave,
	// 退药
	tySave,rxmainPage,getRefundDrug,tyrefund,deltyrefund,
	getDrxExePlanInfo
}